// extracted by mini-css-extract-plugin
export default {"tooltip":"Cn-z","sharingV2":"Dn-z","sharingIconsV2":"En-z","links":"Fn-z","link":"Gn-z","facebookV2":"Hn-z","twitterV2":"In-z","pinterestV2":"Jn-z"};